import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useQuery } from '@tanstack/react-query';
import { getData } from '../utils/apiFunctions';
import { ApiEndpoints, LocationPaths } from '../utils/common';

import { ConfigurationWizard } from '../components';
import { useStateContext } from '../contexts/ContextProvider';

const ConfigurationInitialSetup = () => {
  const { data, isLoading, isSuccess } = useQuery({ queryKey: ['fetchTenantData'], queryFn: () => getData(`${ApiEndpoints.TENANTS}`) });
  const { user, setLocation } = useStateContext();
  const locationData = useLocation();

  useEffect(() => {
    if (isSuccess) {
      data.tenantId = user?.tenantInfo.tenantId;
      data.kaseyaServerAddress = user?.tenantInfo.tenantUrl;
      data.integrationId = user?.tenantInfo.integrationId;
    }
  }, [isSuccess]);

  useEffect(() => {
    if (locationData.pathname === LocationPaths.CONFIGURATION) {
        setLocation('Bitdefender / General / Configuration');
    }
}, []);

  return (
    <>
      {isLoading && <div className='top-1/2 left-1/2 absolute'>
        <gz-progress-spinner spinnerWidth='large' indeterminate />
      </div>}
      {isSuccess && <ConfigurationWizard tenantData={data} />}
    </>
  )
}

export default ConfigurationInitialSetup